import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogComponent } from "../dialog/components/dialog.component";
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cec-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [DialogComponent, TranslateModule, MatIconModule],
})
export class ConfirmationDialogComponent {

    /** Translation key of confirmation dialog message */
    @Input() messageKey: string = '';

    /** Provided value reference */
    private value?: unknown;

    /** Dialog component reference to access */
    @ViewChild(DialogComponent) 
    protected dialog!: DialogComponent;

    /** Returns the confirmation status on click */
    @Output()
    public onButtonClicked = new EventEmitter<unknown>();

    /**
     * Shows the confirmation dialog
     */
    public show(value?: unknown): void {
        this.value = value;
        this.dialog.show();
    }

    /**
     * Returns the confirmation status on click
     * @param success the confirmation status
     */
    protected onClickButton(success: boolean): void {
        
        /** if value is provided, return value */
        if (success && this.value) {
            this.onButtonClicked.emit(this.value);
            return;
        }

        /** if value is provided and success if false, return undefined */
        if (!success && this.value) {
            this.onButtonClicked.emit(undefined);
            return;
        }

        /** else return confirmation status */
        this.onButtonClicked.emit(success);
    }
}
